import { render, staticRenderFns } from "./DepositBalance.vue?vue&type=template&id=4e810c23&"
import script from "./DepositBalance.vue?vue&type=script&lang=js&"
export * from "./DepositBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports